import {h} from 'preact';
import pick from 'ramda/src/pick';
import {adopt} from 'react-adopt';
import {makeMutation} from '../../util/ContainerUtils';
import {
    CreateRmaRequest
} from './query.graphql';

export const SmsMutations = adopt( {
    createRmaRequest: makeMutation( {
        mutation: CreateRmaRequest,
        context: {timeout: 60000}
    } )
} );

export const toRmaLineItemInput = pick( [
    'serialId',
    'brand',
    'lotId',
    'modelId',
    'injury',
    'warrantyCoverageStart',
    'yearsCoverage'
] );

export const toRmaInput = pick( [
    'placeId',
    'groupId',
    'description',
    'email',
    'firstName',
    'lastName',
    'phone',
    'rmaLineItems'
] );

export const SmsRmaInput = pick( ['smsRmas'] );